import { render, staticRenderFns } from "./PlanningEditRoutesV2.vue?vue&type=template&id=b2b4c116&scoped=true"
import script from "./PlanningEditRoutesV2.vue?vue&type=script&lang=js"
export * from "./PlanningEditRoutesV2.vue?vue&type=script&lang=js"
import style0 from "./PlanningEditRoutesV2.vue?vue&type=style&index=0&id=b2b4c116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b4c116",
  null
  
)

export default component.exports